import React from "react";
import health from "assets/icons/health.svg";
import pageLyout from "assets/icons/pageLyout.svg";
import Card from "components/common/Card";
import { useAppSelector } from "utils/hooks";

const policyType = [
  { label: "Plan Name", value: "policyId.policyName" },
  { label: "Plan Type", value: "docEyeOutput.sa_cover_type" },
  { label: "Policy Number", value: "policyId.policyNumber" },
  { label: "Group Name", value: "docEyeOutput.group_policyholder_name" }
];
const policyDetails = [
  { label: "Premium Amount", value: "policyId.premiumAmount" },
  { label: "Sum Insured", value: "docEyeOutput.sumInsured" },
  { label: "Policy Start Date", value: "docEyeOutput.policy_start_date" },
  { label: "Policy End Date", value: "docEyeOutput.policy_end_date" },
  { label: "Policy Renewal Date", value: "docEyeOutput.next_modal_premium_due_date" },
  { label: "No Claim Bonus Amount", value: "docEyeOutput.no_claim_bonus" },
  { label: "Restoration Amount", value: "docEyeOutput.restoration_amount" },
  { label: "Premium Frequency", value: "docEyeOutput.mode_of_payment" }
];
const agentDetails = [
  { label: "Agent Name", value: "docEyeOutput.agent_broker_name" },
  { label: "Agent Contact No.", value: "docEyeOutput.agent_broker_number" },
  { label: "Agent Code", value: "docEyeOutput.agent_broker_code" }
];

export const PolicyDetails = () => {
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.healthQualityData);
  const isLoading = useAppSelector((state) => state.rootReducer.kypSlice.loadingHealthQuality);

  const resolvePath = (obj: any, path: string) => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  return (
    <div className="md:m-6 m-0 my-0 md:my-10">
      <Card className="w-full">
        <div className="flex items-center justify-between bg-[#F1FCF9] pl-4 flex-wrap gap-y-2 py-4 sm:py-0 rounded-xl md:rounded-2xl">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-[50px] h-[50px] bg-[#E5F6EA] flex justify-center items-center rounded-full">
              <img src={health} className="w-5 h-5 sm:w-6 sm:h-6" alt="Health Icon" />
            </div>
            <div className="flex flex-col">
              <span className="text-xs sm:text-sm font-bold">Insurance Company Name</span>
              {isLoading ? <div className="animate-pulse h-4 md:h-6 bg-gray-300 rounded w-40 md:w-72" /> : <p className="font-bold text-sm sm:text-base lg:text-lg">{policyData?.policyId?.insuranceCompanyId?.name}</p>}
            </div>
          </div>
          <img src={pageLyout} alt="Page layout img" className="sm:block hidden" />
        </div>

        {isLoading ? (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
            {policyType.map((item, index) => {
              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
            {policyType.map((item, index) => {
              if (!resolvePath(policyData, item.value)) return;
              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <p className="text-sm font-medium">{resolvePath(policyData, item.value)}</p>
                </div>
              );
            })}
          </div>
        )}

        {isLoading ? (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
            {policyDetails.map((item, index) => {
              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 border-t">
            {policyDetails.map((item, index) => {
              if (!resolvePath(policyData, item.value)) return;
              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <p className="text-sm font-medium">{resolvePath(policyData, item.value)}</p>
                </div>
              );
            })}
          </div>
        )}

        {/* Agent Details */}
        {isLoading ? (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
            {policyDetails.map((item, index) => {
              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 border-t">
            {agentDetails.map((item, index) => {
              if (!resolvePath(policyData, item.value)) return;

              return (
                <div key={index}>
                  <p className="font-bold text-sm">{item.label}</p>
                  <p className="text-sm font-medium">{resolvePath(policyData, item.value)}</p>
                </div>
              );
            })}
          </div>
        )}
      </Card>
    </div>
  );
};
